import React, { Component } from "react";
import AntdForm, {FormProps} from "antd/lib/form";
import "antd/lib/form/style";

const { Item, create, createFormField } = AntdForm;
export default class Form extends Component<FormProps> {
  static Item = Item;
  static create = create;
  static createFormField = createFormField;
  render() {
    return <AntdForm {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/form/index.tsx